const $ = require("jquery")

var AbstractViewModel = require("./AbstractViewModel")
var CustomScreenForm = require("./CustomScreenForm")
var ConsumerInfoWS = require("../ws/ConsumerInfoWS")
var UpdateConsumerInfoWS = require("../ws/UpdateConsumerInfoWS")
var UpdateCustomPropertiesWS = require("../ws/UpdateCustomPropertiesWS")
var Phone = require("../lib/phone")

var xmlToJson = require("./../helpers/xmlToJson")

/**
 * @constructor {ConsumerDetailViewModel}
 * @param {ViewModel} parent 
 */
function ConsumerDetailViewModel(parent) {
  var self = this;

  self.parent = parent;

  AbstractViewModel.apply(this, arguments);
  self.maskedConsumerPhoneBuffer = '';
  self.isEditingConsumerPhone = ko.observable(false);
  self.detailSessionId = ko.observable(null);
  self.detailQueueId = ko.observable(null);
  self.detailLocationId = ko.observable(null);
  self.detailCallAhead = ko.observable(null);
  self.detailForecast = ko.observable(null);
  self.detailName = ko.observable(null);
  self.detailNotes = ko.observable(null);
  self.detailNotifyBehind = ko.observable(false);
  self.detailPartySize = ko.observable(null);
  self.detailPhone = ko.observable(null);
  self.detailPushBack = ko.observable(null);
  self.detailCustomProps = ko.observable({});
  /**
   * @type {CustomScreenForm}
   */
  self.customScreenForm = new CustomScreenForm()

  /** 
   * Transaction Type ID
   * @type {KnockoutObservable<string|number>} 
   */
  self.detailTT = ko.observable(null);

  self.selectedConsumerSubscription = null;

  self.forecastSubscription = null;
  self.originalForecast = null;
  self.hideActionButtons = ko.observable(false);
  self.pushBackMax = ko.observable(null);
  self.pushBackMin = ko.observable(null);
  self.refreshInterval = null;
  self.refreshIntervalDuration = 60 * 1000;
  self.removeConfirmArrived = ko.observable(null);
  self.serverNotes = ko.observable(null);
  self.showMove = ko.observable(false);
  self.showMoveWarning = ko.observable(false);
  self.showMoveWarningMsg = ko.observable(null);
  self.showPushBack = ko.observable(false);
  self.showRemove = ko.observable(false);
  self.showRemoveAll = ko.observable(false);
  self.showSummonWarning = ko.observable(false);
  self.showEarlyAppointmentConfirmation = ko.observable(false);
  self.suppressSummonWarning = ko.observable(false);
  self.selectedConsumerInMultipleQueues = ko.pureComputed(function () {
    var otherLines = self.otherLinesWithConsumer(
      self.parent.selectedConsumer(),
      self.parent.queues()
    )
    return otherLines.length > 0
  })

  self.consumerInfoWS = new ConsumerInfoWS(self);
  self.updateConsumerInfoWS = new UpdateConsumerInfoWS(self);
  self.updateCustomPropertiesWS = new UpdateCustomPropertiesWS(self);

  /**
   * Updates the consumers notes from the server into the detail panel if they started service from the begin service action
   *
   * @method updateCurrentlyServicingNotes
   * @returns none
   */
  self.updateCurrentlyServicingNotes = function () {
    if (self.parent.selectedConsumer()) {
      var currentConsumer = self.parent.currentlyServicing().find(function (spot) {
        return self.parent.selectedConsumer().sessionId === spot.sessionId
      })
      if (currentConsumer && currentConsumer.notes) {
        self.detailNotes(currentConsumer.notes);
        self.serverNotes(currentConsumer.notes);
      }
    }
    self.parent.isLoading(false);
  };


  /**
   * Updates the consumers notes from the server into the detail panel
   *
   * @method updateRecentArrivalConsumerInfo
   * @returns none
   */
  self.updateRecentArrivalConsumerInfo = function () {
    if (self.parent.selectedConsumerNotes()) {
      self.detailNotes(self.parent.selectedConsumerNotes());
      self.serverNotes(self.parent.selectedConsumerNotes());
    }

  };

  /**
  * Updates the consumers notes from the
  * recently arrived consumers panel
  *
  * @method updateRecentArrivalNotes
  * @returns none
  */
  self.updateRecentArrivalNotes = function () {
    // If the user doesn't have a merchantConsumerInfoId, we can look in the recent arrivals
    // but only for users with a phone number
    var recentArrivals = self.parent.listVM.listViewRecentArrivalsWS.spots();
    if (recentArrivals.length > 0) {
      var currentConsumer = recentArrivals.find(function (spot) {
        return self.parent.selectedConsumer().phone === spot.phone
      });
      if (currentConsumer && currentConsumer.notes) {
        self.detailNotes(currentConsumer.notes);
        self.serverNotes(currentConsumer.notes);
      }
    }
    self.parent.isLoading(false);
  }

  self.lastSeen = ko.observable(null);

  self.consumerInfoWS.lastSeen.subscribe(function (val) {
    if (val) {
      self.lastSeen(val);
    }
  })



  /**
   * Arrives the selected consumer
   *
   * @method arriveConsumer
   * @param {ConsumerDetailViewModel} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.arriveConsumer = function (data, evt) {
    var consumer = self.parent.selectedConsumer();

    if (consumer) {
      var queue = self.parent.queuesWS.getQueueById(consumer.queueId);

      if (queue) {
        self.parent.redeemTicket(queue, consumer);
      }
    }
  };


  /**
   * Determines if the forecast has been changed
   *
   * @method callAheadIsDirty
   * @returns {Boolean}
   */
  self.callAheadIsDirty = ko.deferredComputed(function () {
    return self.parent.selectedConsumer() && (self.detailCallAhead() !== self.parent.selectedConsumer().callAhead);
  });


  /**
   * Marks a consumer as checked in
   *
   * @method checkIn
   * @param {SpotModel} consumer
   * @return none
   */
  self.checkIn = function (consumer) {
    self.parent.checkIn(consumer);
  };


  /**
   * Determines if the consumer is being summoned out of order
   *
   * @method checkSummon
   * @returns {Boolean} true
   */
  self.checkSummon = function () {
    var consumer = self.parent.selectedConsumer();

    if (consumer && self.summonBtnEnabled()) {
      var c = consumer.queue().getWaitingSpotBySessionId(consumer.sessionId);

      if (c) {
        var ignoreWarning = self.parent.store.get('summonWarningDisabled');
        var now = new Date();

        // If the ignore warning was set more than 30 days ago,
        // delete the key and enable the warning to be shown again
        if (ignoreWarning && now.valueOf() > Number(ignoreWarning) + (30 * 86400000)) {
          ignoreWarning = false;
          self.parent.store.del('summonWarningDisabled');
        }

        if (c.idx !== 0 && !ignoreWarning) {
          self.summonDialogShow();
        }
        else {
          self.summon();
        }
      }
    }

    return true;
  };


  /**
   * Cleans up subscription to a forecast grabbing request
   *
   * @method cleanup
   * @returns none
   */
  self.cleanup = function () {

    if (self.selectedConsumerSubscription) {
      self.selectedConsumerSubscription.dispose();
    }

    if (self.forecastSubscription) {
      try {
        self.forecastSubscription.dispose();
      }
      catch (e) {
        window.Sentry && window.Sentry.captureException(e);
      }
    }

    window.clearInterval(self.refreshInterval);
  };


  /**
   * Ensures the party size
   *
   * @method correctPartySize
   * @returns none
   */
  self.correctPartySize = function () {
    var qMax = null;
    var qMin = null;
    var q = self.parent.selectedConsumer().queue();

    if (q.maxPartySize) {
      qMax = !qMax ? q.maxPartySize : Math.min(qMax, q.maxPartySize);
    }
    if (q.minPartySize) {
      qMin = !qMin ? q.minPartySize : Math.max(qMin, q.minPartySize);
    }

    if (qMin && Number(self.detailPartySize()) < Number(qMin)) {
      self.detailPartySize(qMin);
    }
    else if (qMax && Number(self.detailPartySize()) > Number(qMax)) {
      self.detailPartySize(qMax);
    }
  };


  /**
   * Whether the button to decrement the forecast is enabled. Will
   * return true if there is a forecast available and it is greater
   * than 5
   *
   * @method decrementButtonEnabled
   * @returns {Boolean}
   */
  self.decrementButtonEnabled = ko.deferredComputed(function () {
    return (self.detailForecast() && Number(self.detailForecast()) > 5);
  });


  /**
   * Determines if the detail panel shows a currently servicing consumer
   * (vs in-line consumer)
   *
   * @method detailIsServicing
   * @returns {Boolean}
   */
  self.detailIsServicing = ko.deferredComputed(function () {
    if (self.parent.currentlyServicing().length > 0) {
      return self.parent.currentlyServicing().filter(function (servicing) {
        return servicing.spot.sessionId === self.parent.selectedConsumerSessionId()
      }).length > 0
    }

    return false;
  });


  /**
   * Action called from the summon warning dialog
   *
   * @method forceSummon
   * @returns none
   */
  self.forceSummon = function () {
    self.summon(true);
  }


  /**
   * Determines if the forecast has been changed
   *
   * @method forecastIsDirty
   * @returns {Boolean}
   */
  self.forecastIsDirty = ko.deferredComputed(function () {
    if (self.detailIsServicing()) {
      return false;
    } else {
      // If the there is a selected consumer and the consumer is queued
      // (not summoned or expired) and the forecasts don't match, then
      // the forecast is dirty
      return self.parent.selectedConsumer() && (self.detailForecast() !== self.originalForecast);
    }
  });


  /**
   * Requests consumer info from the API
   *
   * @method getConsumerInfo
   * @returns none
   */
  self.getConsumerInfo = function () {
    if (!self.detailIsServicing) {
      self.consumerInfoWS.doRequest();
    }
  };


  /**
   * Retrieves the longest wait time for the queue the consumer
   * is currently in. Once the API call resolves, it will update
   * the detailPushBack value, reflected in the PushBack UI
   *
   * @method getLastWaitTime
   * @returns none
   */
  self.getLastWaitTime = function () {
    $.ajax({
      url: '/qless/api/v1/employee/queues/' + self.parent.selectedConsumer().queueId + '/forecast/last',
      method: 'GET',
      success: function (data) {
        var json = xmlToJson.parse(data);
        var duration = 0;
        var wait = json.waitTimes && json.waitTimes.waitTime;

        // Only check that there was a waitTime node
        // There's no need to check for errors here, only success
        if (wait) {
          // Grab the duration (Numerical) value from the XML data
          duration = Number(wait.duration);

          // If a duration was found and it's greater than 0,
          // subtract the users wait from the overall line wait time
          // to create the new wait time (putting the user at the
          // back of the line)
          if (duration && duration > 0) {
            // Create a new max default value
            const max = duration - self.parent.selectedConsumer().forecastDuration();

            // Assign it to the observable which is picked up in
            // the UI
            self.pushBackMax(max);
          }
        }
      }
    });
  };


  /**
   * Prevents non-numeric characters from being entered
   *
   * @method handlePartySizeKeyDown
   * @returns {Boolean}
   */
  self.handlePartySizeKeyDown = function (data, evt) {
    return (self.parent.isNumericInput(evt) || evt.keyCode === 8 || evt.keyCode === 46);
  };


  self.handlePartySizeKeyUp = function (data, evt) {
    if (!(self.parent.isNumericInput(evt) || evt.keyCode === 8 || evt.keyCode === 46)) {
      return false;
    }

    self.correctPartySize();

    return true;
  };

  /**
   * Clearing phone input and allow to update phone number
   *
   * @method clearPhoneInput
   * @returns None
   */
  self.clearPhoneInput = function (data, evt) {
    self.detailPhone('');
    self.isEditingConsumerPhone(true);
    // return true so the operation does not block other events
    return true;
  };

  /**
   * Cancelling edited phone input in detail page
   *
   * @method cancelPhoneInputChange
   * @returns None
   */
  self.cancelPhoneInputChange = function() {
    self.isEditingConsumerPhone(false);
    self.detailPhone(self.maskedConsumerPhoneBuffer);
  }

  /**
   * Reformats the phone input to the specified phone mask
   *
   * @method maskPhone
   * @param {Object} data
   * @param {KeyEvent} evt
   * @returns true
   */
   self.maskPhone = function (data, evt) {
    var el = evt.target;
    var key = evt.keyCode || evt.charCode;
    var del = (key === 8 || key === 46);
    var newVal = self.parent.maskPhone(Phone.normaliseTelephoneNumber(el.value), del);

    // Set the input's text to the calculated return from this operation
    self.detailPhone(newVal);

    // return true so the operation does not block other events
    return true;
  };

  /**
   * Determines if the conditions and settings exist to allow the customer
   * to be moved
   *
   * @method moveButtonEnabled
   * @returns {Boolean}
   */
  self.moveButtonEnabled = ko.deferredComputed(function () {
    var selectedConsumer = self.parent.selectedConsumer();
    var enabled = true;

    if (selectedConsumer) {
      var queue = self.parent.queuesWS.getQueueById(selectedConsumer.queueId);
      var hideMoveButton =
        (queue && queue.disableMove) ||
        (selectedConsumer.callAhead && (queue && queue.disableMoveForCallAheads));

      enabled =
        !hideMoveButton &&
        self.parent.hasRole("host") &&
        self.parent.moveableQueues().length > 0;
    }

    return enabled;
  });


  /**
   * Moves a consumer to another Queue
   *
   * @method moveConsumer
   * @returns none
   */
  self.moveConsumer = function (data, evt) {
    var q = self.parent.queuesWS.getQueueById(self.parent.selectedConsumer().queueId);

    if (self.queueIsDirty()) {

      var ws = new UpdateConsumerInfoWS(self);
      ws.endpoint('/qless/api/v1/employee/queue/' + q.id + '/move');

      ws.addParam('source', 'CEC');
      ws.addParam('queueId', q.id);
      ws.addParam('sessionId', self.parent.selectedConsumer().sessionId);
      ws.addParam('destinationQueue', self.detailQueueId());

      if (self.transactionTypeIsDirty()) {
        ws.addParam('transactionType', self.detailTT());
      }

      ws.doRequest();
    }

    self.parent.hideDetail();
  };


  /**
   * Determines whether the user should be warned before moving a consumer
   *
   * @method moveConsumerCheck
   * @returns none
   */
  self.moveConsumerCheck = function () {
    var q = self.parent.queuesWS.getQueueById(self.detailQueueId());
    var ms = self.parent.messagesWS;
    self.resetMoveWarning();

    if (q) {
      if (q.state().toLowerCase() === 'inactive') {
        self.showMoveWarningMsg(ms.get('confirm.move.inactive.1') + ' ' + ms.get('confirm.move.inactive.2'));
        self.showMoveWarning(true);
      }
      else if (q.state().toLowerCase() === 'closing' || q.state().toLowerCase() === 'closed') {
        self.showMoveWarningMsg(ms.get('confirm.move.closed.1') + ' ' + ms.get('confirm.move.closed.2'));
        self.showMoveWarning(true);
      }
      else {
        self.moveConsumer();
      }
      return true;
    }

    return false;
  }


  /**
   * Hides the Move consumer UI
   *
   * @method moveHide
   * @returns none
   */
  self.moveHide = function () {
    // Hide the move UI
    self.showMove(false);
    // Show the supplemental action buttons
    self.supplementalActionsShow();
    // Reset any warnings
    self.resetMoveWarning();
  };


  /**
   * Show the Move consumer UI
   *
   * @method moveShow
   * @returns none
   */
  self.moveShow = function () {
    if (self.moveButtonEnabled()) {
      // Hide the supplemental action buttons
      self.supplementalActionsRemoveAllForms();
      // Hide the buttons
      self.supplementalActionsHide();
      // Show the move UI
      self.showMove(true);
    }
  };


  /**
   * Determines if the name has been changed
   *
   * @method nameIsDirty
   * @returns {Boolean}
   */
  self.nameIsDirty = ko.deferredComputed(function () {
    var selectedConsumer = self.parent.selectedConsumer()
    var detailName = self.detailName()
    var hasInputName = detailName !== "" && detailName !== null && typeof detailName !== "undefined"

    // BUG/NOTE: There is a change for this to run again and `selectedConsumer` will
    // be `null` because the Queue spots are being updated AFTER the Spot was
    // updated, so `selectedConsumer` will briefly update to `null`
    if (selectedConsumer && hasInputName) {
      return detailName != selectedConsumer.merchantInfoName;
    }

    return false;
  });


  /**
   * Determines if the notes have been changed
   *
   * @method notesAreDirty
   * @returns {Boolean}
   */
  self.notesAreDirty = ko.deferredComputed(function () {
    // Check to see if the notes from the server are different
    // than the one in the notes input
    if (self.detailIsServicing()) {
      return self.detailNotes() != self.serverNotes();
    } else {
      return self.parent.selectedConsumer() && self.detailNotes() != self.parent.selectedConsumer().notes;
    }
  });

  /**
  * Determines if the notes have been changed
  *
  * @method notesAreDisabled
  * @returns {Boolean}
  */
  self.notesAreDisabled = ko.deferredComputed(function () {
    // If the merchant does not have a merchantConsumerInfoId we can look in the recent arrivals
    if (self.parent.selectedConsumer() && !self.parent.selectedConsumer().merchantConsumerInfoId && self.detailIsServicing()) {
      if (self.parent.selectedConsumer().phone) {
        var foundConsumer = self.parent.listVM.listViewRecentArrivalsWS.spots().find(function (spot) {
          if (spot.phone) {
            return self.parent.selectedConsumer().phone === spot.phone;
          }
        });
        var canEditNotes = (foundConsumer) ? false : true;
        return canEditNotes;
      } else {
        return true;
      }
    }
  });


  /**
   * Determines if the party size has been changed
   *
   * @method partySizeIsDirty
   * @returns {Boolean}
   */
  self.partySizeIsDirty = ko.deferredComputed(function () {
    if (self.parent.selectedConsumer()) {
      // If the phone hasn't been changed at all, it will match the
      // masked phone value. If it does, then the phone is not dirty
      if (self.detailPartySize() === self.parent.selectedConsumer().partySize) {
        return false;
      }
      // Otherwise, evaluate the value against the raw phone number
      else {
        return self.detailPartySize() !== self.parent.selectedConsumer().partySize;
      }
    }
    return false;
  });


  /**
   * Prevents users from trying to modify phone numbers to blank
   *
   * @method phoneBlankCheck
   * @returns {Boolean}
   */
  self.phoneBlankCheck = function () {
    if (self.parent.selectedConsumer() && self.parent.selectedConsumer().phone) {
      if (self.detailPhone() === '' || self.detailPhone() === null) {
        return !(self.parent.selectedConsumer().phone !== '' && self.parent.selectedConsumer().phone !== null);
      }
    }
    return true;
  }


  /**
   * Determines if the phone has been changed
   *
   * @method phoneIsDirty
   * @returns {Boolean}
   */
  self.phoneIsDirty = ko.deferredComputed(function () {
    if (self.parent.selectedConsumer()) {
      // If the phone hasn't been changed at all, it will match the
      // masked phone value. If it does, then the phone is not dirty
      if (self.detailPhone() === self.parent.selectedConsumer().maskedPhone()) {
        return false;
      }
      // Otherwise, evaluate the value against the raw phone number
      else {
        return self.detailPhone() !== self.parent.selectedConsumer().phone;
      }
    }
    return false;
  });


  /**
   * Determines a phone number with country code
   *
   * @method phoneWithCountryCode
   * @param {String} phone
   * @returns {String}
   */
  self.phoneWithCountryCode = function (phone) {
    var defaultCountryCode = null;

    var l = self.parent.locationsWS.getLocationById(self.parent.selectedConsumer().queue().locationId);

    if (l && l.defaultPhoneCountryCode) {
      if (defaultCountryCode === null) {
        defaultCountryCode = l.defaultPhoneCountryCode;
      }
      if (defaultCountryCode !== l.defaultPhoneCountryCode) {
        defaultCountryCode = null;
      }
    }

    if (defaultCountryCode !== null) {
      phone = phone.trim();

      if (phone.length <= 10) {
        phone = '+' + defaultCountryCode + phone;
      }
      else if (phone.charAt(0) === '0') {
        phone = '+' + defaultCountryCode + phone.substring(1)
      }
    }

    return phone;
  };


  /**
   * Pushes an Consumer back in the line, giving them more time to arrive
   *
   * @method pushBack
   * @returns none
   */
  self.pushBack = function () {
    var q = self.parent.queuesWS.getQueueById(self.parent.selectedConsumer().queueId);

    if (self.pushBackIsDirty()) {
      var ws = new UpdateConsumerInfoWS(self);
      ws.endpoint('/qless/api/v1/employee/queue/' + q.id + '/pushBack');

      ws.addParam('queueId', q.id);
      ws.addParam('sessionId', self.parent.selectedConsumer().sessionId);
      ws.addParam('time', self.detailPushBack());

      ws.doRequest(function () {
        self.parent.hideDetail();
      });
    }
  };


  /**
   * Determines if the PushBack decrement button is enabled
   *
   * @method pushBackDecEnabled
   * @returns {Boolean}
   */
  self.pushBackDecEnabled = ko.deferredComputed(function () {
    return self.detailPushBack() > self.pushBackMin();
  });


  /**
   * Hides the Push Back UI
   *
   * @method pushBackHide
   * @returns none
   */
  self.pushBackHide = function () {
    // Hide the pushback UI
    self.showPushBack(false);
    // Show the supplemental action buttons
    self.supplementalActionsShow();
  };


  /**
   * Determines if the PushBack increment button is enabled
   *
   * @method pushBackIncEnabled
   * @returns {Boolean}
   */
  self.pushBackIncEnabled = ko.deferredComputed(function () {
    return self.detailPushBack() < self.pushBackMax();
  });


  /**
   * Determines if the pushback value differs from the current forecast
   *
   * @method pushBackIsDirty
   * @returns {Boolean}
   */
  self.pushBackIsDirty = ko.deferredComputed(function () {
    return (self.detailPushBack() !== self.detailForecast());
  });


  /**
   * Determines whether the the push back supplemental action is enabled
   *
   * @method pushBackOptionBtnEnabled
   * @returns {Boolean}
   */
  self.pushBackOptionBtnEnabled = ko.deferredComputed(function () {
    var c = self.parent.selectedConsumer();

    if (c) {
      if (c.isLastInLine() || self.showPushBack()) {
        return false;
      }
    }

    return true;
  });


  /**
   * Determines whether the the push back supplemental action is visible
   *
   * @method pushBackOptionBtnVisible
   * @returns {Boolean}
   */
  self.pushBackOptionBtnVisible = ko.deferredComputed(function () {
    var c = self.parent.selectedConsumer();

    return (c && !c.callAhead);
  });


  /**
   * Determines whether the the call ahead supplemental action is visible
   *
   * @method callAheadButtonVisible
   * @return {Boolean}
   */
  self.callAheadButtonVisible = ko.deferredComputed(function () {
    var c = self.parent.selectedConsumer();

    return (c && c.queue().disableManualCheckIn != true && !self.pushBackOptionBtnVisible());
  });

  /**
   * Presents the Push Back UI
   *
   * @method pushBackShow
   * @returns none
   */
  self.pushBackShow = function () {
    if (self.pushBackOptionBtnEnabled()) {
      var step = self.parent.forecastStep;
      var dur = self.parent.selectedConsumer().forecastDuration();
      var pbMinBase = Math.floor(dur / step);
      var pbMinRem = Math.floor(dur % step)
      var pbMin = (pbMinBase * step) + (pbMinRem * step);

      // Set the initial value of the input to the current forecast wait time
      self.detailPushBack(pbMin);

      // Set the inital value of the max pushback to the current forecast
      self.pushBackMax(self.parent.selectedConsumer().forecastDuration());

      // Make sure the user can't be pushed back ahead of their current wait
      // by setting the pushBackMin, which will be used in the UI to restrict
      // the decrement action (root unitDecrement() action)
      self.pushBackMin(pbMin);

      // Request the longest wait time (back of the line). This will update
      // the detailPushBack when the API call resolves
      self.getLastWaitTime();

      // Hide any other UI forms
      self.supplementalActionsRemoveAllForms();

      // Hide the supplemental action buttons
      self.supplementalActionsRemoveAllForms();

      // Hide the buttons
      self.supplementalActionsHide();

      // Show the pushback UI
      self.showPushBack(true);
    }
  };


  /**
   * Determines if the queue for the consumer has been changed
   *
   * @method queueIsDirty
   * @returns {Boolean}
   */
  self.queueIsDirty = ko.deferredComputed(function () {
    var c = self.parent.selectedConsumer();

    return (c && self.detailQueueId() != c.queueId);
  });


  /**
   * Re-adds a consumer from the expired list back in line
   *
   * @method rejoin
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.rejoin = function (data, evt) {
    var c = self.parent.selectedConsumer();

    if (c) {
      self.parent.enterQueueWS.reset();
      self.parent.enterQueueWS.addParam('queueId', c.queueId);

      if (c.phone) {
        self.parent.enterQueueWS.addParam('phone', c.phone);
      } 

      if (c.merchantInfoName) {
        self.parent.enterQueueWS.addParam('name', c.merchantInfoName)
      }

      if (!c.merchantInfoName & !c.phone && c.receiptNumber ) {
        self.parent.enterQueueWS.addParam('name', c.receiptNumber)
      }

      if (c.uuid) {
        self.parent.enterQueueWS.addParam('uuid', c.uuid);
        if (c.receiptNumber) {
          self.parent.enterQueueWS.addParam('receiptNumber', c.receiptNumber);
        }
      }

      if (c.partySize) {
        self.parent.enterQueueWS.addParam('partySize', c.partySize);
      }

      if (c.locale) {
        self.parent.enterQueueWS.addParam('locale', c.locale);
      }

      self.parent.enterQueueWS.doRequest();
      self.parent.hideDetail();
    }
  };


  /**
   * Determines if the Remove button is enabled
   *
   * @method removeButtonEnabled
   * @returns {Boolean}
   */
  self.removeButtonEnabled = ko.deferredComputed(function () {
    var c = self.parent.selectedConsumer();
    var vis = true;

    if (self.parent.selectedConsumer()) {
      var q = self.parent.queuesWS.getQueueById(c.queueId);

      vis = !(q.disableRemove || (c.callAhead && q.disableRemoveForCallAheads));
    }

    return vis;
  });


  /**
   * Decides whether to remove the Consumer from a single Queue
   * or prompt the Employee to confirm removing the Consumer
   * from all lines.
   *
   * @param data
   * @param event
   */
  self.removeConsumer = function (data, event) {

    if (self.selectedConsumerInMultipleQueues()) {
      var selectedQueue = self.parent.queuesWS.getQueueById(self.parent.selectedConsumer().queueId);
      var location = self.parent.locationsWS.getLocationById(selectedQueue.locationId);
      var removeFromAllWithoutConfirmation = location.removeFromAllWithoutConfirmation;

      if (!removeFromAllWithoutConfirmation) {
        self.showRemove(false);
        self.showRemoveAll(true);
      } else {
        self.removeFromAllLines(data, event)
      }
    } else {
      self.removeFromLine(data, event);
    }
  };

  /**
   * Removes a consumer from the line
   *
   * @method removeFromLine
   * @returns none
   */
  self.removeFromLine = function (data, evt) {
    var el = evt.target;
    var arrived = (el && el.getAttribute('data-arrived') == 'true');
    var q = self.parent.queuesWS.getQueueById(self.parent.selectedConsumer().queueId);
    var ws = new UpdateConsumerInfoWS(self);

    ws.endpoint('/qless/api/v1/employee/queue/' + q.id + '/leave');
    ws.addParam('queueId', q.id);
    ws.addParam('sessionId', self.parent.selectedConsumer().sessionId);
    if (arrived) {
      ws.addParam('arrived', true);
    };
    ws.doRequest();

    self.showRemoveAll(false);
    self.parent.hideDetail();
  };

  /**
   * Remove Selected Consumer from all joined Queues
   *
   */
  self.removeFromAllLines = function (data, event) {
    var selectedConsumer = self.parent.selectedConsumer();
    var arrived =
      event.target && event.target.getAttribute("data-arrived") == "true";

    var lines = this.otherLinesWithConsumer(
      selectedConsumer,
      self.parent.queues()
    );

    // ...include current Queue
    lines.push(
      self.parent.queuesWS.getQueueById(self.parent.selectedConsumer().queueId)
    );

    this.removeFromLines(selectedConsumer, lines, arrived);

    self.showRemoveAll(false);
    self.removeHide();
    self.parent.hideDetail();
  };

  /**
   * Remove a Consumer's Spot from the given lines
   *
   * @param {SpotModel} spot  the consumer's spot
   * @param {[Queues]} lines list of queues
   */
  self.removeFromLines = function (spot, lines, arrived) {
    var ws = new UpdateConsumerInfoWS(self);

    lines.forEach(function (line) {
      ws.endpoint("/qless/api/v1/employee/queue/" + line.id + "/leave");
      ws.addParam("queueId", lines.id);
      ws.addParam("sessionId", spot.sessionId);
      // Mark as arrived when leaving the current queue
      if (arrived && line.id == spot.queueId) {
        ws.addParam("arrived", true);
      }
      ws.doRequest();
    });
  };

  /**
   * Find other Queues the Selected Conumer is holding a Spot in.
   *
   * @param {SpotModel} selectedSpot the Consumer's Spot (Session)
   * @param {[QueueModel]} lines all queues at the Location
   */
  self.otherLinesWithConsumer = function (selectedSpot, lines) {
    return lines.filter(function (line) {
      var sessions = line.spots().map(function (s) {
        return s.sessionId;
      });

      return (
        line.id != selectedSpot.queueId &&
        sessions.indexOf(selectedSpot.sessionId) !== -1
      );
    });
  };

  /**
   * Hides the Remove Customer UI
   *
   * @method removeHide
   * @returns none
   */
  self.removeHide = function () {
    // Hide the form UI
    self.showRemove(false);
    // Ensure the confirmation message is not shown
    self.removeConfirmArrived(false);
    // Show the supplemental action buttons
    self.supplementalActionsShow();
  };


  /**
   * Shows the Remove Customer UI
   *
   * @method showHide
   * @returns none
   */
  self.removeShow = function () {
    if (self.removeButtonEnabled()) {
      // Hide any other forms that are currently on display
      self.supplementalActionsRemoveAllForms();
      // Hide the supplemental action buttons
      self.supplementalActionsRemoveAllForms();
      // Hide the buttons
      self.supplementalActionsHide();
      // Show the UI
      self.showRemove(true);
    }
  };


  /**
   * Formats and returns the "are you sure" message for the Remove Customer UI
   *
   * @method removeTitle
   * @returns {String}
   */
  self.removeTitle = ko.deferredComputed(function () {
    var c = self.parent.selectedConsumer();
    var msg = self.parent.messagesWS.get('about.to.remove.from.queue');

    if (c) {
      msg = msg.replace('{0}', '<span class="remove-consumer-name">' + self.parent.selectedConsumer().privateName() + '</span>').replace('{1}', '<span class="remove-queue-name">' + c.queueName + '</span>');
    }

    return msg;
  });


  /**
   * Resets the add consumer interface to a default state
   *
   * @method reset
   * @returns none
   */
  self.reset = function () {

    // Clear custom screen inputs before clearing the other consumer details
    // because `customScreens` are derived from those details.
    self.customScreenForm.cleanInputs(self.customScreens())

    self.detailCallAhead(null);
    self.detailForecast(null);
    self.detailName(null);
    self.detailNotes(null);
    self.serverNotes(null);
    self.detailNotifyBehind(false);
    self.detailPartySize(null);
    self.detailPhone(null);
    self.detailPushBack(null);
    self.detailQueueId(null);
    self.detailLocationId(null);
    self.detailSessionId(null);
    self.detailTT(null);
    self.detailCustomProps({});

    self.pushBackMax(null);
    self.pushBackMin(null);
    self.removeConfirmArrived(null);

    self.showMove(false);

    self.showPushBack(false);
    self.showRemove(false);
    self.showSummonWarning(false);

    self.suppressSummonWarning(false);

    self.updateConsumerInfoWS = new UpdateConsumerInfoWS(self);

    // Ensure that supplemental action buttons are visible
    self.supplementalActionsShow();

    // Ensure that all supplemental action forms are hidden
    self.supplementalActionsRemoveAllForms();

    self.cleanup();
    self.resetMoveWarning();
  };


  /**
   * Resets the move warning dialog
   *
   * @method resetMoveWarning
   * @returns none
   */
  self.resetMoveWarning = function () {
    self.showMoveWarning(false);
    self.showMoveWarningMsg(null);
  };
  
  /** 
   * Updates the ViewModel properties based on values in the SpotModel
   * 
   * @method setConsumer
   * @param {SpotModel} consumer
   * @returns none
   */
  self.setConsumer = function (consumer) {
    if (consumer) {
      // Queue ID
      if (consumer.queueId) {
        self.detailQueueId(consumer.queueId);
        self.detailLocationId(consumer.queue().locationId)
      }

      if (consumer.sessionId) {
        self.detailSessionId(consumer.sessionId)
      }

      // Forecast wait
      if (!self.detailIsServicing()) {
        // Consumers that are being serviced are no longer waiting  
        self.forecastSubscription = consumer.forecastDuration.subscribe(function (val) {
          if (self.detailForecast() == null || self.detailForecast() < val) {
            self.originalForecast = val;
            self.detailForecast(val);
          }
        });
      }

      if (!self.detailName()) {
        if (consumer.hasARealName()) {
          self.detailName(consumer.merchantInfoName);
        }
      }

      // Phone number
      if (!self.detailPhone()) {
        self.maskedConsumerPhoneBuffer = consumer.maskedPhone();
        self.detailPhone(consumer.maskedPhone());
        self.isEditingConsumerPhone(false);
      }

      // Party Size
      if (!self.detailPartySize()) {
        self.detailPartySize(consumer.partySize);
      }

      // Call Ahead
      self.detailCallAhead(consumer.callAhead);

      // Notes
      if (!self.detailNotes()) {
        var appointmentNotes = (consumer.appointment && typeof consumer.appointment.notes === "string") ? consumer.appointment.notes : null;
        self.detailNotes(consumer.notes || appointmentNotes);
      }

      // Transaction Type
      if (consumer.transactionType) {
        self.detailTT(consumer.transactionType.id);
      }

      if (consumer.customProps && consumer.customProps.length >= 1) {
        self.detailCustomProps(consumer.customPropsAsObject())
        self.customScreenForm.updateInitialValues(self.customScreens(), self.detailCustomProps())
      }
    }
  };


  /**
   * Sets a refresh interval to ensure that the data presented is current
   *
   * @method show
   * @returns none
   */
  self.show = function (consumer) {
    self.setConsumer(consumer);

    var queue = self.parent.queuesWS.getQueueById(self.detailQueueId());

    // Why do we only do this if there is a Queue?
    // OH! Is it because a Spot that is being Serviced is not in a Queue?
    if (queue) {
      self.refreshInterval = window.setInterval(function () {
        queue.updateAllSpots();
      }, self.refreshIntervalDuration);

      // Update the Detail view when the Selected Consumer updates.
      self.selectedConsumerSubscription = self.parent.selectedConsumer.subscribe(function (selectedConsumer) {
        // N.B. We can't subscribe to `consumer` because that object will be discared when the `WS` objects
        // update and bring in new Spot data
        if (selectedConsumer) {
          // TODO: Abdul's changes to sync Consumer Notes could go here instead of being scattered
          // They could be gated by self.detailIsServicing
          self.getConsumerInfo();
          self.setConsumer(selectedConsumer);
        }
      });
    }
  };


  /**
   * Shows the supplemental action buttons in the UI
   *
   * @method showSummonedConsumerActions
   * @returns {Boolean}
   */
  self.showArriveAction = function () {
    var c = self.parent.selectedConsumer();

    if (c) {
      if (c.isSummoned()) {
        return true;
      }
      else if (c.isExpired() && self.parent.hasRole('ticketTaker.' + c.queueId) && self.parent.recordServiceTransactions()) {
        return true;
      }
    }

    return false;
  };


  /**
   * Shows the supplemental action buttons in the UI
   *
   * @method showExpiredConsumerActions
   * @returns {Boolean}
   */
  self.showRejoinAction = function () {
    var c = self.parent.selectedConsumer();
    return (c) ? (c.isExpired() && self.parent.hasRole('host.' + c.queueId)) : false;
  };

  self.isPhoneEditable = ko.deferredComputed(function() {
    var consumer = self.parent.selectedConsumer();
    return consumer ? !consumer.isExpired() : true;
  });

  /**
   * Shows the supplemental action buttons in the UI
   *
   * @method showQueuedConsumerActions
   * @returns {Boolean}
   */
  self.showQueuedConsumerActions = function () {
    var c = self.parent.selectedConsumer();
    return (c) ? !c.isExpired() && !c.isSummoned() : false;
  };


  /**
   * Returns the description string if there is only one Transaction Type
   *  available
   *
   * @method singleTTDescription
   * @returns {String}
   */
  self.singleTTDescription = ko.deferredComputed(function () {
    var spot = self.parent.selectedConsumer();
    var description = ""

    if (spot)  {
      var transactionType = spot.queue().defaultTransactionType()
      description = (transactionType) ? transactionType.description : ""
    }

    return description
  });

  /**
   * Hides the summon out of order warning
   *
   * @method summonDialogHide
   * @returns none
   */
  self.summonDialogHide = function () {
    // Hide the move UI
    self.showSummonWarning(false);
    // Show the supplemental action buttons
    self.supplementalActionsShow();
  }


  /**
   * Shows the summon out of order warning
   *
   * @method summonDialogShow
   * @returns none
   */
  self.summonDialogShow = function () {
    // Hide the supplemental action buttons
    self.supplementalActionsRemoveAllForms();
    // Hide the buttons
    self.supplementalActionsHide();
    // Show the move UI
    self.showSummonWarning(true);
  };


  /**
   * Hides action buttons
   *
   * @method supplementalActionsHide
   * @returns none
   */
  self.supplementalActionsHide = function () {
    self.hideActionButtons(true);
  };


  /**
   * Shows action buttons
   *
   * @method supplementalActionsShow
   * @returns none
   */
  self.supplementalActionsShow = function () {
    self.hideActionButtons(false);
  };


  /**
   * Summons a consumer (presumably out of order) via their session id
   *
   * @method summon
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.summon = function (data, evt) {
    var consumer = self.parent.selectedConsumer();

    if (consumer && self.summonBtnEnabled()) {
      // True will be passed by the checkSummon method
      // If the value of suppressSummonWarning is true
      // then we will store a localStorage item so the
      // user will not be bugged in the future
      if (data === true && self.suppressSummonWarning()) {
        var dt = new Date();
        self.parent.store.set("summonWarningDisabled", dt.valueOf());
      }

      var summonAndHideDetailPanel = function () {
        self.summonOverride(consumer);
        self.parent.hideDetail();
      };

      var location = self.parent.locationsWS.getLocationById(
        consumer.queue().locationId
      );

      if (self.parent.employeeNeedsTicketClassifierForLocation(location)) {
        self.parent.settingsShow(summonAndHideDetailPanel);
      } else {
        summonAndHideDetailPanel();
      }
    }
  };

  self.summonOverride = function(consumerSpot) {
    self.parent.issueTicketOverride(consumerSpot);
  }


  /**
   * Whether the summon button is available. This allows consumers to be
   * summoned out of order.
   *
   * @method summonBtnEnabled
   * @returns none
   */
  self.summonBtnEnabled = ko.deferredComputed(function () {
    var c = self.parent.selectedConsumer();
    var vis = false;

    if (self.parent.selectedConsumer() && self.parent.hasRole('resourceAdmin.' + self.detailQueueId())) {
      vis = !c.callAhead && self.parent.userCanSummonOutOfOrder();
    }

    return vis;
  });


  /**
   * Hides all supplemental action forms
   *
   * @method supplementalActionsRemoveAllForms
   * @returns none
   */
  self.supplementalActionsRemoveAllForms = function () {
    // Hide the summon warning
    self.summonDialogHide();
    // Hide the push back UI form
    self.pushBackHide();
    // Hide the remove consumer from line UI form
    self.removeHide();
    // Hide the move consumer UI form
    self.moveHide();
    // Show the buttons
    self.supplementalActionsShow();
  };


  /**
   * Proxy for the queue.supportsCallAhead property
   *
   * @method supportsCallAhead
   * @returns {Boolean}
   */
  self.supportsCallAhead = ko.deferredComputed(function () {
    if (self.parent.selectedConsumer()) {
      var q = self.parent.selectedConsumer().queue()
      return q.supportsCallAhead && q.supportsCallAhead === true
    }
    return false;
  })


  /**
   * Toggles the action interface represented by the clicked element
   *
   * @method toggleAction
   * @param {Object} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.toggleAction = function (data, evt) {
    var el = evt.target;
    var elAction = el.getAttribute('data-action');

    switch (elAction) {
      // Called when the 'checked in' button is clicked
      case 'checkIn':
        self.checkIn(self.parent.selectedConsumer());
        break;

      // Called when the 'yes' button is clicked from within the 'remove'
      // workflow ('remove' below)
      case 'confirmArrivedRemoved':
        self.removeConfirmArrived(!self.removeConfirmArrived());
        break;

      // Called when the 'move' button is clicked
      case 'move':
        if (self.moveButtonEnabled()) {
          var consumer = {
            queueId: self.detailQueueId(),
            customProps: self.parent.selectedConsumer().customProps,
            name: self.detailName(),
            notes: self.detailNotes(),
            phone: self.parent.selectedConsumer().phone,
            sessionId: self.detailSessionId(),
            locale: self.parent.selectedConsumer().locale,
            receiptNumber: self.parent.selectedConsumer().receiptNumber,
            firstName: self.parent.selectedConsumer().firstName,
            lastName: self.parent.selectedConsumer().lastName,
          }

          self.parent.moveConsumer(consumer);
        }

        break;

      // Called when the 'push back' button is clicked
      case 'pushBack':
        if (self.showPushBack()) {
          self.pushBackHide();
        }
        else {
          self.pushBackShow();
        }
        break;

      // Called when the 'remove' button is clicked
      case 'remove':
        if (self.showRemove()) {
          self.removeHide();
        }
        else {
          self.removeShow();
        }
        break;

      // Called when the 'summon' button is clicked
      case 'summon':
        if (self.parent.userCanSummonOutOfOrder()) {
          self.checkSummon();
        }
        break;
    }
  };


  /**
   * Flips the summon warning
   *
   * @method toggleSummonWarning
   * @returns none
   */
  self.toggleSummonWarning = function () {
    self.suppressSummonWarning(!self.suppressSummonWarning());
  };


  /**
   * Determines if the transaction type has been changed
   *
   * @method transactionTypeIsDirty
   * @returns {Boolean}
   */
  self.transactionTypeIsDirty = ko.deferredComputed(function () {
    var transactionTypeId = (self.parent.selectedConsumer() && self.parent.selectedConsumer().transactionType)
      ? self.parent.selectedConsumer().transactionType.id
      : null;

    // The Spot doesn't have a selected Transaction Type, so it cannot be dirtied.
    if (transactionTypeId === null) {
      return false;
    }

    // If detailTT is no longer null, then it was modified
    // So, compare it to the current value
    return (self.detailTT() !== null && self.detailTT() !== transactionTypeId)
  });


  /**
   * Commit any changed data to the server
   *
   * @method update
   * @returns none
   */
  self.update = function (force) {
    if (force || self.updateBtnEnabled()) {
      if (self.phoneBlankCheck()) {
        self.updateCallAhead();
        self.updateConsumer();
        self.updateForecast();
        self.updatePartySize();
        self.updatePhone();
        self.updateTransactionType();

        // TODO: This should verify that all the operations were successful and then hide the detail panel.
        self.parent.hideDetail();
      }
    }
  };


  /**
   * Determines whether an update action is available
   *
   * @function updateBtnEnabled
   * @returns {Boolean}
   */
  self.updateBtnEnabled = ko.deferredComputed(function () {
    return this.areConsumerDetailsDirty() && self.phoneBlankCheck();
  }, this);

  /**
   * @method areConsumerDetailsDirty
   */
  this.areConsumerDetailsDirty = ko.deferredComputed(this._areConsumerDetailsDirty, this)

  /**
   * Commits call ahead status changes to server
   *
   * @method updateCallAhead
   * @returns none
   */
  self.updateCallAhead = function () {
    if (self.callAheadIsDirty()) {
      var l = self.parent.locationsWS.getLocationById(self.parent.selectedConsumer().queue().locationId);

      if (l) {
        let ws = new UpdateConsumerInfoWS(self);
        ws.endpoint('/qless/api/v1/employee/location/' + l.id + '/callAhead');

        ws.addParam('sessionId', self.parent.selectedConsumer().sessionId);
        ws.addParam('callAhead', self.detailCallAhead());

        ws.doRequest();
      }
    }
  };


  /**
   * Commits name or note changes to server
   *
   * @method updateConsumer
   * @returns none
   */
  self.updateConsumer = function () {
    if (self.notesAreDirty() || self.nameIsDirty()) {
      var ws = new UpdateConsumerInfoWS(self);
      var selectedConsumer = self.parent.selectedConsumer();

      if (self.detailIsServicing()) {
        if (self.parent.selectedConsumer().merchantConsumerInfoId) {
          ws.endpoint('/qless/api/v1/employee/merchant/' + parent.locations()[0].merchantId + '/consumer/' + selectedConsumer.merchantConsumerInfoId + '/notes');
          ws.addParam('sessionId', selectedConsumer.sessionId);
          ws.addParam('notes', self.detailNotes());
          ws.doRequest();
        } else {
          ws.addParam('notes', self.detailNotes());
          var foundConsumer = self.parent.listVM.listViewRecentArrivalsWS.spots().find(function (spot) {
            return spot.phone === selectedConsumer.phone;
          })
          ws.endpoint('/qless/api/v1/employee/merchant/' + parent.locations()[0].merchantId + '/consumer/' + foundConsumer.id + '/notes');
          ws.doRequest();
          return;
        }
        return;
      }

      ws.endpoint('/qless/api/v1/employee/queue/' + self.parent.selectedConsumer().queueId + '/consumer');

      ws.addParam('queueId', self.parent.selectedConsumer().queueId);
      ws.addParam('sessionId', self.parent.selectedConsumer().sessionId);

      if (self.nameIsDirty()) {
        ws.addParam('name', self.detailName());
      }

      if (self.notesAreDirty()) {
        ws.addParam('notes', self.detailNotes());
      }

      ws.doRequest();
    }

    if (self.canSubmitCustomProperties()) {

      var customProperties = self.customScreenForm.getValues(self.customScreens())
      var screenInputs = self.customScreenForm.getInputs(self.customScreens())

      var parameters = {
        locationId: self.detailLocationId(),
        sessionId: self.detailSessionId(),
        customProperties: customProperties
      } 
      self.updateCustomPropertiesWS.updateConsumerSession(parameters, null, function customPropsError() {
        self.parent.errorMessages(self.updateCustomPropertiesWS.errorDetails.message);
        self.parent.showError(true);
      });
    }
  };


  /**
   * Commits forecast changes to server
   *
   * @method updateForecast
   * @returns none
   */
  self.updateForecast = function () {
    if (self.forecastIsDirty()) {
      var ws = new UpdateConsumerInfoWS(self);
      ws.endpoint('/qless/api/v1/employee/queue/' + self.parent.selectedConsumer().queueId + '/forecast/' + self.parent.selectedConsumer().sessionId);

      ws.addParam('queueId', self.parent.selectedConsumer().queueId);
      ws.addParam('sessionId', self.parent.selectedConsumer().sessionId);

      ws.addParam('forecast', self.detailForecast());
      ws.addParam('forecastUnits', 'MINUTES');

      if (self.detailNotifyBehind()) {
        ws.addParam('updateAllBehind', true);
      }

      ws.doRequest();
    }
  };


  /**
   * Commits party size changes to server
   *
   * @method updatePartySize
   * @returns none
   */
  self.updatePartySize = function () {
    if (self.partySizeIsDirty()) {
      let ws = new UpdateConsumerInfoWS(self);
      ws.endpoint('/qless/api/v1/employee/queue/' + self.parent.selectedConsumer().queueId + '/partySize');

      ws.addParam('sessionId', self.parent.selectedConsumer().sessionId);
      ws.addParam('queueId', self.parent.selectedConsumer().queueId);
      ws.addParam('partySize', self.detailPartySize());

      ws.doRequest();
    }
  };


  /**
   * Commits phone changes to server
   *
   * @method updatePhone
   * @returns none
   */
  self.updatePhone = function () {
    var queueId = self.parent.selectedConsumer().queueId;
    var q = self.parent.queuesWS.getQueueById(queueId);
    var sessionId = self.parent.selectedConsumer().sessionId;
    
    if (!self.phoneBlankCheck()) {
      return;
    }

    if (self.phoneIsDirty()) {
      var ws = new UpdateConsumerInfoWS(self);
      ws.endpoint('/qless/api/v1/employee/location/' + q.locationId + '/phone');

      ws.addParam('locationId', q.locationId);
      ws.addParam('sessionId', sessionId);

      // Make sure that we are not sending masked characters (#) in the
      // consumers phone number
      var dPhone = self.detailPhone() && String(self.detailPhone()).replace(/[^0-9#]/g, '');
      var cPhone = self.parent.selectedConsumer().phone && self.parent.selectedConsumer().phone.replace(/[^0-9#]/g, '');

      if (dPhone.indexOf('#') > -1) {
        var dPhoneParts = dPhone.split('');
        var cPhoneParts = cPhone.split('');

        dPhoneParts.forEach(function (char, idx) {
          if (char === '#') {
            dPhoneParts[idx] = cPhoneParts[idx];
          }
        });

        dPhone = dPhoneParts.join('');
      }

      var p = self.phoneWithCountryCode(dPhone);

      ws.addParam('newPhone', p);

      ws.doRequest(function () {
        var updatedQueues = self.parent.queues().filter(function(queueInstance) {
            return queueInstance.spots().some(function(spotInstance) {
              return spotInstance.sessionId === sessionId;
            });
        });

        if (updatedQueues && updatedQueues.length) {
          updatedQueues.forEach(function (queueInstance) {
            queueInstance.updateAllSpots(true);
          });
        }
      });
    }
  };


  /**
   * Commits changes to the transaction type back to the server
   *
   * @method updateConsumer
   * @returns none
   */
  self.updateTransactionType = function () {
    if (self.transactionTypeIsDirty()) {
      var ws = new UpdateConsumerInfoWS(self);
      ws.endpoint('/qless/api/v1/employee/queue/' + self.parent.selectedConsumer().queueId + '/transactionType');

      ws.addParam('queueId', self.parent.selectedConsumer().queueId);
      ws.addParam('sessionId', self.parent.selectedConsumer().sessionId);

      ws.addParam('transactionType', self.detailTT());

      ws.doRequest();
    }
  };


  /**
   * Proxy to the location.usePartySize member
   *
   * @method usePartySize
   * @returns {Boolean}
   */
  self.usePartySize = ko.deferredComputed(function () {
    if (self.parent.selectedConsumer()) {
      var l = self.parent.locationsWS.getLocationById(self.parent.selectedConsumer().queue().locationId);

      return (l && l.usePartySize === true);
    }

    return false;
  });


  /**
   * The Queue that the selected Consumer Spot is in.
   * @return {QueueModel}
   */
  this.currentQueue = ko.pureComputed(function () {
      var currentQueueId = this.parent.selectedConsumer().queueId
      var queue = this.parent.queuesWS.getQueueById(currentQueueId)

      return queue
  }, this)


  this.canSelectTransactionTypes = ko.pureComputed(function () {
    var currentQueue = self.currentQueue();
    return (currentQueue) ? currentQueue.hasTransactionTypes() : false;
  }, this)


  self.earlyAppointmentConfirmationShow = function () {
    self.supplementalActionsRemoveAllForms();
    self.supplementalActionsHide();
    self.showEarlyAppointmentConfirmation(true);
  };

  self.earlyAppointmentConfirmationHide = function() {
    self.showEarlyAppointmentConfirmation(false);
    self.parent.hideDetail();
  }

  self.handleEarlyAppointmentConfirm = function(data, event) {
    self.summonOverride(self.parent.selectedConsumer());
    self.parent.hideDetail();
  }

  self.handleEarlyAppointmentCancel = function(data, event) {
    self.earlyAppointmentConfirmationHide();
  }

  self.canEditCustomProperties = ko.deferredComputed(function () {
    var features = self.parent.featureToggles();
    return features.editCustomProperties
  })

  this.showCustomScreens = ko.deferredComputed(function () {
    var isEnabled = this.parent.isFeatureEnabled('editCustomProperties')
    return isEnabled
  }, self)


  /**
   * Indicates if the Queue of the Spot uses Custom Screens
   * @method hasCustomScreens
   * @returns {KnockoutComputed<boolean>}
   */
  this.hasCustomScreens = ko.deferredComputed(function () {
    var customScreens = self.customScreens()
    return (customScreens && customScreens.length > 0)
  })

  /**
   * Indicate whether Custom Screens are still being loaded
   *
   * @returns {KnockoutObservable<boolean>}
   */
  self.isLoadingCustomScreens = ko.deferredComputed(function () {
    var locationCustomScreens = self.locationCustomScreens()
    return (locationCustomScreens === undefined)
  })

  /**
   * Custom Screens filtered to match the currently selected Queue/Transaction Type
   * @type {KnockoutComputed<CustomScreenModel[]>}
   */
  this.customScreens = ko.deferredComputed(function () {
    /** @type {Array<CustomScreenModel>} */
    var screens = this.locationCustomScreens()
    var selectedTransactionTypeId = self.detailTT()

    if (!screens) {
      return []
    }

    var queue = self.parent.queuesWS.getQueueById(self.detailQueueId())

    var transactionTypeId = null
    if (selectedTransactionTypeId) {
      transactionTypeId = selectedTransactionTypeId 
    } else if (queue && queue.defaultTransactionType()) {
      transactionTypeId = queue.defaultTransactionType().id
    }

    return screens.filter(function (screen) {
      // when a screen is associated with a Transaction Type, 
      // it should only be shown if that Transaction Type is selected
      if (screen.transactionTypeId && transactionTypeId) {
        return (screen.transactionTypeId == transactionTypeId)
      }

      return true
    })
  }, this)

  /**
   * All Custom Screens at the Spot's Location.
   * (You most likely want to use `customScreens` instead)
   * 
   * @returns {KnockoutComputed<Array<CustomScreenModel>|undefined>} `undefined` if the Custom Screens have not finished loading
   */
  self.locationCustomScreens = ko.deferredComputed(function () {
    var queueId = this.detailQueueId()
    var customScreensObservable = this.customScreensForQueue(queueId)

    // don't have enough data to get custom screens
    if (customScreensObservable === false) {
      return []
    }

    // create the dependency; not sure if this will actually help with anything
    var customScreens = customScreensObservable()
    var loaded = customScreensObservable.loaded()

    // Indicate loading with undefined (we don't know we have or not)
    if (loaded === false) {
      return undefined
    }

    // return the value if the screens are loaded
    return customScreens
  }, this)

  self.customScreenInputs = ko.deferredComputed(function() {
    var customScreens = self.customScreens()
    var customProperties = self.detailCustomProps()

    if (!customScreens || customScreens.length == 0) {
      return []
    }

    return self.customScreenForm.getInputs(customScreens, customProperties)

  }, this)

  this.consumerHasCustomProps = ko.deferredComputed(this._consumerHasCustomProps, this)

  this.canSubmitCustomProperties = ko.deferredComputed(this._canSubmitCustomProperties, this)

  /**
   * @type {KnockoutComputed<boolean>}
   */
  this.showCustomPropertiesReadOnly = ko.deferredComputed(function () {
    var hasCustomProps = this.consumerHasCustomProps()
    var canEditCustomProperties = this.parent.isFeatureEnabled("editCustomProperties");

  return (hasCustomProps && !canEditCustomProperties)
  }, this)

  this.showTicketNumber = ko.computed(function () {
    var selectedConsumer = this.parent.selectedConsumer()

    // When a Numbered/Ticketed Queueable is updated to have a Name, the Receipt
    // Number is changed to the Consumer's name (because the Ticket Number is
    // placed in the Name field)
    // If the Employee has provided a Numbered/Ticket Spot with a Name, we'll only
    // show the Name field
    return selectedConsumer && selectedConsumer.canShowTicketNumber()
  }, this, { deferEvaluation: true })


  // Expose the object as it's own API
  return self;
};

ConsumerDetailViewModel.prototype = Object.create(AbstractViewModel.prototype);
ConsumerDetailViewModel.prototype.constructor = ConsumerDetailViewModel;

/**
 * 
 * @param {SpotModel} spot 
 * @returns Array<CustomScreenModel>
 */
ConsumerDetailViewModel.prototype.customScreensForQueue = function(queueId) {
  var locationId = this.detailLocationId()
  if (!locationId) {
    return false;
  }

  var location = this.parent.locationsWS.getLocationById(locationId);
  return location.customScreens
}

/**
 *
 * @param {Array<CustomScreenModel>} customScreens 
 * @param {Array<Object<string, string>>} customProperties 
 */
ConsumerDetailViewModel.prototype.populateCustomFields = function(customProperties) {
  var self = this;
  Object.keys(customProperties).forEach(function (name) {
    var observableField = self.customFieldStore(name)
    observableField(customProperties[name])
  })
}

/**
 * 
 * @param {Array<CustomScreenModel>} customScreens
 * @returns {Array<CustomScreenFieldModel>}
 */
ConsumerDetailViewModel.prototype.allCustomFields = function(customScreens) {
  return (customScreens) 
    ? customScreens.reduce(function (allFields, screen) { return allFields.concat(screen.fields) }, [])
    : []
}


ConsumerDetailViewModel.prototype.customFieldValidate = function(data, event) {
  console.log("Validating", data, event)
}

ConsumerDetailViewModel.prototype._areConsumerDetailsDirty = function () {
  return (
    this.callAheadIsDirty()
    || this.forecastIsDirty()
    || this.nameIsDirty()
    || this.notesAreDirty()
    || this.partySizeIsDirty()
    || this.phoneIsDirty()
    || this.transactionTypeIsDirty()
    || this.canSubmitCustomProperties()
  )
} 

ConsumerDetailViewModel.prototype._canSubmitCustomProperties = function () {
  return (this.parent.isFeatureEnabled("editCustomProperties")) 
    ? this.customScreenForm.isDirty(this.customScreens()) && this.customScreenForm.isValid(this.customScreens())
    : false
}

ConsumerDetailViewModel.prototype._consumerHasCustomProps = function () {
  return (this.parent.selectedConsumer()
    && this.parent.selectedConsumer().customProps
    && this.parent.selectedConsumer().customProps.length > 0
  )
}

module.exports = ConsumerDetailViewModel;
